import { Rating, styled, type Theme } from '@mui/material';

export const TitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 0),
}));

export const ReadonlyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  '& div': {
    display: 'flex',
  },
}));

export const HoverButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'end',
  gap: theme.spacing(1),
}));

export const CustomRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconFilled': {
    color: theme.palette.primary.main,
  },
  '& .MuiRating-iconHover': {
    color: theme.palette.primary.light,
  },
}));

export const FieldRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconFilled': {
    color: theme.palette.action.active,
  },
  '& .MuiRating-iconHover': {
    color: theme.palette.action.active,
  },
}));

export const PercentContainer = styled('div')(({ theme }) => ({
  width: '80%',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(0.5),
}));

const getPercentBackgroundColor = (theme: Theme, percent: number) => {
  if (percent === 0) {
    return undefined;
  }

  if (percent >= 80) {
    return theme.palette.success.light;
  }
  if (percent >= 60) {
    return theme.palette.warning.light;
  }
  if (percent >= 30) {
    return theme.palette.warning.main;
  }
  return theme.palette.error.main;
};

export const PercentBar = styled('div', {
  shouldForwardProp: (prop) => prop !== 'percent',
})<{ percent?: number }>(({ theme, percent }) => ({
  backgroundColor: getPercentBackgroundColor(theme, percent ?? 0),
  width: `${percent ?? 100}%`,
  height: 28,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
